var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-section"},[_c('div',{staticClass:"pull-right"},[_c('lang-switch'),_c('user')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }